import React, { useRef } from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
function StarRating() {
  return <div className="flex gap-1 mb-4" aria-label="5 out of 5 stars" data-id="element-278">
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-279" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-280" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-281" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-282" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-283" />
    </div>;
}
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section className="w-full bg-[#141414] py-20 md:py-28 px-4" data-id="element-284">
      <div className="max-w-6xl mx-auto" data-id="element-285">
        {/* Header */}
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-286">
          <p className="text-[#c41e3a] font-semibold tracking-[0.25em] uppercase text-sm mb-3" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-287">
            Client Reviews
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-288">
            WHAT THEY'RE SAYING
          </h2>
          <div className="section-divider w-24 mx-auto" data-id="element-289" />
        </motion.div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-290">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-7 flex flex-col" data-id="element-291">
            <StarRating data-id="element-292" />
            <blockquote className="text-gray-300 text-base leading-relaxed flex-1 mb-6 italic" data-id="element-293">
              "Best barbershop in Hialeah. Jonathan and his team are
              professionals. My son has been going for 2 years and always leaves
              looking fresh."
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-[#2a2a2a]" data-id="element-294">
              <div className="w-10 h-10 rounded-full bg-[#c41e3a]/20 border border-[#c41e3a]/30 flex items-center justify-center text-[#c41e3a] font-bold text-sm" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-295">
                HC
              </div>
              <div data-id="element-296">
                <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-297">
                  Happy Client
                </p>
                <p className="text-gray-500 text-xs" data-id="element-298">Verified Review</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#1c1c1c] border border-[#c41e3a]/40 rounded-lg p-7 flex flex-col relative overflow-hidden" data-id="element-299">
            {/* Highlight accent */}
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#c41e3a]" aria-hidden="true" data-id="element-300" />
            <StarRating data-id="element-301" />
            <blockquote className="text-gray-300 text-base leading-relaxed flex-1 mb-6 italic" data-id="element-302">
              "Walk-ins always welcome and they never make you wait too long.
              Clean shop, great vibes, best fade in the area."
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-[#2a2a2a]" data-id="element-303">
              <div className="w-10 h-10 rounded-full bg-[#c41e3a]/20 border border-[#c41e3a]/30 flex items-center justify-center text-[#c41e3a] font-bold text-sm" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-304">
                RC
              </div>
              <div data-id="element-305">
                <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-306">
                  Regular Client
                </p>
                <p className="text-gray-500 text-xs" data-id="element-307">Verified Review</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-7 flex flex-col" data-id="element-308">
            <StarRating data-id="element-309" />
            <blockquote className="text-gray-300 text-base leading-relaxed flex-1 mb-6 italic" data-id="element-310">
              "The attention to detail is unmatched. I won't go anywhere else.
              This is the only place I trust with my hair."
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-[#2a2a2a]" data-id="element-311">
              <div className="w-10 h-10 rounded-full bg-[#c41e3a]/20 border border-[#c41e3a]/30 flex items-center justify-center text-[#c41e3a] font-bold text-sm" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-312">
                LC
              </div>
              <div data-id="element-313">
                <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-314">
                  Loyal Customer
                </p>
                <p className="text-gray-500 text-xs" data-id="element-315">Verified Review</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}